import router from "@/router";
import Axios from "axios";
import store from "../store";

const axios = Axios.create({
  baseURL: process.env.VUE_APP_URL,
  timeout: 60 * 1000 * 5,
});

axios.interceptors.request.use(
  function (config) {
    try {
      var token = localStorage.getItem("access_Token") || store.state["authPageModule"].access_Token;
      if (token) {
        const refreshToken = localStorage.getItem("refresh_token");
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Re-Authorization"] = `Bearer ${refreshToken}`;
      }
    } catch (error) {}

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const code = parseInt(error.response && error.response.status);
    const originalRequest = error.config;

    if (code === 401 && !originalRequest._retry) {

      originalRequest._retry = true;
      return axios({
        method: "POST",
        url: "/admin/loginRefresh",
      }).then((res) => {
        if (res.status === 200) {
          localStorage.setItem("access_Token", res.data["access_Token"]);
          localStorage.setItem("refresh_token", res.data["refresh_token"]);
        }
        return axios(originalRequest);
      });
    } else if (code === 403) {
      store.commit("snackbarFailed", {
        value: true,
        msg: error.response.data,
      });
      router.push({ path: "/" });
    } else if (code === 400) {
      
    } else if (code === 406) {
      console.log("logout");
    
      localStorage.removeItem("access_Token");
      localStorage.removeItem("refresh_token");
    
      router.push({ path: "/" });
    }else if (code >= 500) {
      store.commit("snackbarFailed", {
        value: true,
        msg: error.response.data.error_message,
      });
    }

    /* */
    return Promise.reject(error);
  }
);

export default axios;
